import { Icon } from '@material-ui/core';
import { GalleryIcon } from 'pages/CreateVehicle/icons/GalleryIcon';
import styled from 'styled-components';
import { useCameraViewContext } from '../../context';
import { useField } from 'react-final-form';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { useBulkAddImages } from 'pages/ListerVehicleUploadV2/hooks/useBulkAddImages';

const MuiIcon = styled(Icon)`
  color: #fff;
`;

const HiddenInput = styled.input`
  display: none;
`;

export const GalleryInput = () => {
  const {
    level1SectionId,
    imageLoading,
    imageIndex,
    setGalleryImage,
    setIndex,
    isVideoMode,
    setInputVideo
  } = useCameraViewContext();

  const { input: typeInput } = useField(`${level1SectionId}.images.${imageIndex}.type`);
  const {
    input: { value: vehicleId }
  } = useField('vehicleId');
  const {
    input: { value: serverId }
  } = useField(`${level1SectionId}.id`);

  const bulkAdd = useBulkAddImages(level1SectionId!);

  const handleFileChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = e.target.files;
      if (!files || !files.length) return;

      if (isVideoMode) {
        setInputVideo(files[0])
        return
      }

      if (!typeInput.value) {
        if (files.length && files.length >= 50) {
          toast.error('You can only upload up to 50 images');
          return;
        }

        const images = Array.from(files);

        const mappedInput = await Promise.all(
          images.map(async (img, i) => {
            const order = Number(imageIndex) + i;
            const entityId = `${serverId}-${order}`;
            return {
              entityId,
              file: await img.arrayBuffer()
            };
          })
        );

        await bulkAdd(mappedInput);
        setIndex(imageIndex + mappedInput.length, true);
      } else {
        const file = files[0];
        const reader = new FileReader();
        reader.onload = e => {
          if (e.target?.result) {
            setGalleryImage(e.target.result as string);
          }
        };
        reader.readAsDataURL(file);
      }
    },
    [typeInput, setGalleryImage, bulkAdd, vehicleId, serverId]
  );

  const handleClick = () => {
    if (imageLoading) return;
    document.getElementById('gallery-input')?.click();
  };

  return (
    <>
      <HiddenInput
        type="file"
        accept={isVideoMode ? 'video/*' : 'image/*'}
        max={50}
        multiple={!typeInput.value}
        onChange={handleFileChange}
        id="gallery-input"
      />
      <MuiIcon onClick={handleClick}>
        <GalleryIcon />
      </MuiIcon>
    </>
  );
};
